import * as React from 'react';
import styles from '../styles/wizards/AddFilterPresetWizard.scss';
import * as _ from 'lodash';
import AddFilterPresetForm from '../forms/add_filter_preset_wizard/AddFilterPresetForm';
import { __ } from '../core/utils';
import Localization from '../helpers/Localization';
import { subscribe } from 'react-contextual';
import { connect } from 'react-redux';
import {
  createFilterPreset,
  hideFilterPreset,
} from '../redux/actions/general/filter_preset';

const AddFilterPresetWizard = function (props) {
  const _handleSubmit = (formData) => {
    createFilterPreset(formData.name);

    hideFilterPreset();
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>
            {__('wizard.add-filter-preset.title.create-filter-preset')}
          </span>
          <span>
            {__('wizard.add-filter-preset.subtitle.create-filter-preset')}
          </span>
        </div>
      </div>
      <div className={styles.body}>
        <AddFilterPresetForm onSubmit={_handleSubmit} />
      </div>
    </>
  );
};

export default connect()(
  subscribe(Localization, 'localization')(AddFilterPresetWizard)
);
